<header class="app-header">
    <div class="logo">
        <h2>Controlant</h2>
    </div>
    <h1 class="aaTitle account-admin-header">Account Admin</h1>

    <div class="session-info">
        <div class="access">User time: <em>{{ currentTime }}</em></div>
        <div class="toolbar">
            <button class="aaButton transparent" [routerLink]="['/login', { logout: true }]" title="Log out">
                <fa-icon [icon]="faPowerOff" [fixedWidth]="true"></fa-icon>Log out
            </button>
        </div>
    </div>
    <div class="user-info">
        <!-- Switch organization button -->
        <button class="aaButton organizations-button" (click)="switchOrganization()" *ngIf="isSSOFlow && isMultiOrg || (organizationsLoaded && userOrganizations.length > 1)">Switch Company</button>
        <div class="user">Welcome
            <em>{{ currentUser.firstName }} {{ currentUser.lastName }} ({{ currentUser.username }})</em>
        </div>
        <div class="company">Company:
            <em>{{ currentCustomer.name }}</em> ({{ currentUser.accessLevel }})
        </div>
    </div>

</header>

<!-- Commented out temporarily for COMS-664
<header class="app-header">
    <div class="app-header-logo">
        <div class="logo"><h2>Controlant</h2></div>
        <h1 class="aaTitle account-admin-header">Account Admin</h1>
    </div>

    <div class="session-info">
        <div class="access">User time: <em>{{ currentTime }}</em></div>
        <div class="toolbar">
            <button class="aaButton transparent" [routerLink]="['/login', { logout: true }]" title="Log out">
                <fa-icon [icon]="faPowerOff" [fixedWidth]="true"></fa-icon>Log out
            </button>
        </div>
    </div>

    <div class="user-info">
        <div class="user">Welcome
            <em>{{ currentUser.firstName }} {{ currentUser.lastName }} ({{ currentUser.username }})</em>
        </div>
        <div class="company">Company:
            <em>{{ currentCustomer.name }}</em> ({{ currentUser.accessLevel }})
        </div>
    </div>


    <div class="app-header-user">
        <div class="user-info">
            <a routerLinkActive="active" [routerLink]="['user-admin', 'my-info']">
                <fa-icon [icon]="faUser" [fixedWidth]="true"></fa-icon><span class="user-info-label">{{ currentUser.firstName }} {{ currentUser.lastName }} ({{ currentUser.username }})</span>
            </a>
            <div class="user-tooltip">
                <div class="user">Name:
                    <em>{{ currentUser.firstName }} {{ currentUser.lastName }}</em>
                </div>
                <div class="user">Username:
                    <em>{{ currentUser.username }}</em>
                </div>
                <div class="company">Company:
                    <em>{{ currentCustomer.name }}</em> ({{ currentUser.accessLevel }})
                </div>
                <div class="access">User time: <em>{{ currentTime }}</em></div>
            </div>
        </div>

        <div class="session-info">
            <div class="toolbar">
                <button class="aaButton transparent" [routerLink]="['/login', { logout: true }]" title="Log out">
                    <fa-icon [icon]="faPowerOff" [fixedWidth]="true"></fa-icon>Log out
                </button>
            </div>
        </div>
    </div>
</header>-->

<aside class="app-navigation">
    <nav>
        <h4 class="aaTitle">My Control Panel</h4>
        <ul id="user-nav">
            <li>
                <a routerLinkActive="active" [routerLink]="['user-admin', 'user-settings']">
                    <fa-icon [icon]="faGlobeAmericas" [fixedWidth]="true"></fa-icon>User Settings</a>
            </li>
            <li>
                <a routerLinkActive="active" [routerLink]="['user-admin', 'audit-trails']">
                <fa-icon [icon]="faCheckSquare" [fixedWidth]="true"></fa-icon>Audit Trails</a>
            </li>
        </ul>
    </nav>

    <nav *ngIf="currentUser.accessLevel === 'ADMIN'">
        <h4 class="aaTitle">Company Control Panel</h4>
        <h5>All Solutions</h5>
        <ul id="common-nav">
            <li>
                <a routerLinkActive="active" [routerLink]="['company-admin', 'company-settings']">
                <fa-icon [icon]="faSlidersH" [fixedWidth]="true"></fa-icon>Account Settings</a>
            </li>
            <li>
                <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="['company-admin', 'users']">
                    <fa-icon [icon]="faUsers" [fixedWidth]="true"></fa-icon>User Management</a>
            </li>
            <!--<li>
                <a routerLinkActive="active" [routerLink]="['company-admin', 'security-settings']">
                    <fa-icon [icon]="faShieldAlt" [fixedWidth]="true"></fa-icon>Security Settings</a>
            </li>
            <li>
                <a routerLinkActive="active" [routerLink]="['company-admin', 'custom-properties']">
                    <fa-icon [icon]="faTags" [fixedWidth]="true"></fa-icon>Custom Properties</a>
                <ul *ngIf="currentUrl.includes('/r/company-admin/custom-properties')">
                    <li>
                        <a routerLinkActive="active" [routerLink]="['/r', 'company-admin', 'custom-properties', 'create']">
                            <fa-icon [icon]="faPlus" [fixedWidth]="true"></fa-icon>New Custom Property</a>
                    </li>
                </ul>
            </li>
            <li>
                <a routerLinkActive="active" [routerLink]="['company-admin', 'inspection-properties']">
                    <fa-icon [icon]="faBookOpen" [fixedWidth]="true"></fa-icon>Inspection Properties</a>
                <ul *ngIf="currentUrl.includes('/r/company-admin/inspection-properties')">
                    <li>
                        <a routerLinkActive="active" [routerLink]="['/r', 'company-admin', 'inspection-properties', 'create']">
                            <fa-icon [icon]="faPlus" [fixedWidth]="true"></fa-icon>New Inspection Property</a>
                    </li>
                </ul>
            </li>-->
            <li>
                <a routerLinkActive="active" [routerLink]="['company-admin', 'properties']">
                    <fa-icon [icon]="faBookOpen" [fixedWidth]="true"></fa-icon>Shipment Properties</a>
            </li>
        </ul>

        <h5>Supply Chain Monitoring</h5>
        <ul id="scm-nav">
            <li>
                <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="['scm-management', 'projects']">
                    <fa-icon [icon]="faArchive" [fixedWidth]="true"></fa-icon>Projects</a>
                <ul *ngIf="currentUrl.includes('/r/scm-management/projects')">
                    <li>
                        <a routerLinkActive="active" [routerLink]="['scm-management', 'projects', 'create']">
                            <fa-icon [icon]="faPlus" [fixedWidth]="true"></fa-icon>Create New Project</a>
                    </li>
                </ul>
            </li>
            <li>
                <a routerLinkActive="active" [routerLink]="['scm-management', 'products']">
                    <fa-icon [icon]="faBox" [fixedWidth]="true"></fa-icon>Products</a>
            </li>
            <!-- <li><a [routerLink]="['']"><fa-icon [icon]="faTachometer" [fixedWidth]="true"></fa-icon> Loggers</a></li>
            <li><a [routerLink]="['']"><fa-icon [icon]="faMapMarker" [fixedWidth]="true"></fa-icon> Locations</a></li>
            <li><a [routerLink]="['']"><fa-icon [icon]="faFileO" [fixedWidth]="true"></fa-icon> Shipment Templates</a></li>
            <li><a [routerLink]="['']"><fa-icon [icon]="faFileO" [fixedWidth]="true"></fa-icon> Contacts Templates</a></li>
            <li><a [routerLink]="['']"><fa-icon [icon]="faFileO" [fixedWidth]="true"></fa-icon> Warnings Templates</a></li> -->
        </ul>
        <h5>Report Subscriptions</h5>
        <ul id="subscription-nav">
            <li>
                <a routerLinkActive="active" [routerLink]="['subscriptions', 'user-subscriptions']">
                <fa-icon [icon]="faUserChart" [fixedWidth]="true"></fa-icon>User Subscriptions</a>
            </li>
            <li>
                <a routerLinkActive="active" [routerLink]="['subscriptions', 'lane-subscriptions']">
                <fa-icon [icon]="faRoute" [fixedWidth]="true"></fa-icon>Lane Subscriptions</a>
            </li>
        </ul>
        <div *ngIf="userUsesClaims">
            <h5>Access Management</h5>
            <ul>
                <li>
                    <a routerLinkActive="active" [routerLink]="['company-admin', 'user-claims']">
                        <fa-icon [icon]="faUserCircle" [fixedWidth]="true"></fa-icon>User Access</a>
                </li>
                <li>
                    <a routerLinkActive="active" [routerLink]="['company-admin', 'role-claims']">
                        <fa-icon [icon]="faIdCardAlt" [fixedWidth]="true"></fa-icon>Role Access</a>
                    <ul *ngIf="currentUrl.includes('/r/company-admin/role-claims')">
                        <li><a routerLinkActive="active" [routerLink]="['company-admin', 'role-claims', 'create-role']">
                            <fa-icon [icon]="faPlus" [fixedWidth]="true"></fa-icon>Create New Role</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!--
                <h5>FM Resources</h5>
                <ul id="fm-nav">
                    <li><a [routerLink]="['']"><fa-icon [icon]="faCube" [fixedWidth]="true"></fa-icon> Collections & Assets</a></li>
                    <li><a [routerLink]="['']"><fa-icon [icon]="faCube" [fixedWidth]="true"></fa-icon> Measuring Points</a></li>
                    <li><a [routerLink]="['']"><fa-icon [icon]="faFileO" [fixedWidth]="true"></fa-icon> MP Templates</a></li>
                </ul>
        -->
    </nav>
</aside>

<main class="app-main">
    <div class="main-wrap">
        <router-outlet></router-outlet>
    </div>
</main>
